export class DocumentItemAddedEvent {
    public DocumentTypeId: number;

    constructor(documentTypeId: number) {
        this.DocumentTypeId = documentTypeId;
    }
}
